export default __webpack_public_path__ + "static/media/221091_finishlist.93bbaecc.pdf";